import DotersModalOtpContainer from './DotersModalOtpContainer';

export default DotersModalOtpContainer;
